import { ROOT_QUERY_INCLUDE_VARIABLE_NAME } from "../graphql/compositionFragments/constants";
export default function dedupeSubQueries(subQueryGroups) {
    const seenHashes = new Set();
    const deduped = [];
    const deduplicatedIncludeVariables = {};
    subQueryGroups.forEach((subQueryGroup)=>{
        const includeVariableName = `${subQueryGroup.prefix}___${ROOT_QUERY_INCLUDE_VARIABLE_NAME}`;
        if (seenHashes.has(subQueryGroup.documentHashWithVariables)) {
            deduplicatedIncludeVariables[includeVariableName] = false;
            return;
        }
        seenHashes.add(subQueryGroup.documentHashWithVariables);
        deduped.push(subQueryGroup);
    });
    return {
        dedupedSubQueryGroups: deduped,
        deduplicatedIncludeVariables
    };
}

//# sourceMappingURL=dedupeSubQueries.js.map